import FileAccessCheckboxes from './FileAccessCheckboxes.component';

export default FileAccessCheckboxes;